var _a;
export class VeltService {
}
_a = VeltService;
VeltService.selectedCommentsMap = new Map();
VeltService.subscribers = new Map();
VeltService.isSubscribed = false;
/* eslint-disable @typescript-eslint/no-explicit-any */
VeltService.getCommentElement = () => {
    try {
        const velt = window.Velt;
        if (velt === null || velt === void 0 ? void 0 : velt.getCommentElement) {
            return velt.getCommentElement();
        }
        return null;
    }
    catch (error) {
        _a.catchError('Error getting comment element:', error);
        return null;
    }
};
VeltService.addManualComment = ({ context, location, }) => {
    try {
        const commentElement = _a.getCommentElement();
        if (!commentElement)
            return Promise.resolve(null);
        return commentElement.addManualComment({ context, location });
    }
    catch (error) {
        _a.catchError('Error adding manual comment:', error);
        return Promise.resolve(null);
    }
};
VeltService.updateContext = ({ annotationId, context, }) => {
    try {
        const commentElement = _a.getCommentElement();
        if (!commentElement)
            return Promise.resolve(null);
        return commentElement.updateContext(annotationId, context);
    }
    catch (error) {
        _a.catchError('Error updating context:', error);
    }
};
VeltService.subscribeToSelectedCommentsMap = (id, subscriber) => {
    try {
        _a.subscribeToSelectedAnnotationsMapSingleton();
        _a.subscribers.set(id, subscriber);
    }
    catch (error) {
        _a.catchError('Error subscribing to selected comments map:', error);
    }
};
VeltService.unsubscribeFromSelectedCommentsMap = (id) => {
    try {
        _a.subscribers.delete(id);
    }
    catch (error) {
        _a.catchError('Error unsubscribing from selected comments map:', error);
    }
};
VeltService.catchError = (message, otherProperties) => {
    var _b;
    try {
        const url = 'https://api.velt.dev/sa';
        let properties = {};
        if (otherProperties && typeof otherProperties === 'object') {
            properties = Object.assign(Object.assign({}, properties), otherProperties);
        }
        if (message) {
            properties.message = message;
        }
        properties.sdkVersion = (_b = window.Velt) === null || _b === void 0 ? void 0 : _b.version;
        const body = {
            type: 'track',
            data: {
                event: 'tiptapVeltCommentsError',
                properties: properties,
            },
        };
        //   fetch(url, {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(body),
        //   });
    }
    catch (error) {
        // handle error here
    }
};
VeltService.subscribeToSelectedAnnotationsMapSingleton = () => {
    var _b;
    try {
        if (_a.isSubscribed) {
            return;
        }
        const commentElement = _a.getCommentElement();
        if (commentElement && typeof (commentElement === null || commentElement === void 0 ? void 0 : commentElement.getSelectedComments) === 'function') {
            (_b = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getSelectedComments()) === null || _b === void 0 ? void 0 : _b.subscribe((comments) => {
                const selectedCommentsMap = new Map();
                comments === null || comments === void 0 ? void 0 : comments.forEach((comment) => {
                    if (comment === null || comment === void 0 ? void 0 : comment.annotationId) {
                        selectedCommentsMap.set(comment === null || comment === void 0 ? void 0 : comment.annotationId, true);
                    }
                });
                // Check if the maps are different
                const areMapsEqual = (map1, map2) => {
                    if (map1.size !== map2.size)
                        return false;
                    for (const [key, value] of map1) {
                        if (map2.get(key) !== value)
                            return false;
                    }
                    return true;
                };
                // Skip update if maps are equal
                if (areMapsEqual(selectedCommentsMap, _a.selectedCommentsMap || new Map())) {
                    return;
                }
                _a.updateSelectedCommentsMap(selectedCommentsMap);
            });
            _a.isSubscribed = true;
        }
    }
    catch (error) {
        return new Map();
    }
};
VeltService.updateSelectedCommentsMap = (selectedCommentsMap) => {
    try {
        _a.selectedCommentsMap = selectedCommentsMap;
        _a.subscribers.forEach((subscriber) => {
            if (typeof subscriber === 'function') {
                subscriber(_a.selectedCommentsMap);
            }
        });
    }
    catch (error) {
        _a.catchError('Error updating selected comments map:', error);
    }
};
